import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { mediaQueryUp } from 'components/utils/breakpoint'
import getStaticPagesByType from 'lib/utils/getStaticPagesByType'
import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: grid;
  grid-template: "content" auto / 1fr;
  gap: ${rem(16)};

  ${mediaQueryUp.tablet} {
    grid-template: "nav content" 1fr / ${rem(248)} minmax(0, 1fr) ;
  }
`

const Nav = styled.div`
  grid-area: nav;
  display: none;

  ${mediaQueryUp.tablet} {
    display: block;
  }
`

const StickyNavContent = styled.div`
  position: sticky;
  top: ${rem(24)};
`

const Content = styled.div`
  grid-area: content;
`

const types = [
  'termsAndConditions',
  'bookingPolicies',
  'privacyPolicy',
  'flights',
  'frequentFlyerPrograms',
  'bestPriceTerms',
  'giftcardTermsAndConditions',
  'specialProductsPromotions',
  'feeSchedule',
  'luxPlusTermsAndConditions',
  'societeTermsAndConditions',
  'societeFAQs',
  'shopTermsAndConditions',
  'shopFAQs',
]

interface Props {
  className?: string
}

function WithSideBar(props: PropsWithChildren<Props>) {
  const {
    className,
    children,
  } = props

  return <Container className={(className)}>
    <Content>{children}</Content>
    <Nav>
      <StickyNavContent>
        {getStaticPagesByType(types).map((item) => <ClickableListItem
          key={item.type}
          role="menuitem"
          to={item.url?.to}
          title={item.text}
          titleFormat="uppercase"
          size="medium"
        />)}
      </StickyNavContent>
    </Nav>
  </Container>
}

export default WithSideBar
